import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {concat, of, Subject} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, switchMap} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class StudentsService {

	class$: any;
	classinput$ = new Subject<string>();

	constructor(private httpClient: HttpClient) {
	}

	getStudentMaster(id) {
		return this.httpClient.get('/students/getstudentinfo/', {params: {'id': id}});
	}

	getStudents(id,type) {
		return this.httpClient.get('/students/student/',{params : {'id' :  id,'type' : type}});
	}
	// getStudents() {
	//   return this.httpClient.get('/students/student/');
	// }

	getStudent(params) {
		return this.httpClient.get('/students/student/',{params:params});
	}

	postStudent(student) {
		return this.httpClient.post('/students/student/', student);
	}

	UploadStudentImage(data){
		return this.httpClient.post('/students/student_image_upload/', data);
	}

	GetStudentImage(studentmasterId,type){
		return this.httpClient.get('/students/student_image_upload/',{params:{'student_id':studentmasterId,'type':type}});
	}

	updateStudent(id, student) {
		return this.httpClient.patch(`/students/studentmaster/${id}/`, student);
	}

	getClassStudents(class_id){
		return this.httpClient.get('/students/class_student/',{params:{'class_id':class_id}})
	}

	getClassesStudents(params){
		return this.httpClient.get('/students/class_student/',{params:params});
	}

	getusersfrmstudents() {
		return this.httpClient.get('/students/getuserfrmstudents/');
	}

	checkRegNoTaken(params) {
		return this.httpClient.get('/students/checkRegNoTaken/', {params: params});
	}

	checkEmailTaken(params) {
		// const params = {'email': email};
		// if (p) { params['parentid'] = p; }
		return this.httpClient.get('/students/checkEmailTaken/', {params: params});
	}

	getParentsMultiSelect(term) {
		return this.httpClient.get('/parent/queryparentsbyterm/', {params: {'term': term}});
	}

	// getStudentClass_academicyear(student) {
	//   return this.httpClient.get('/students/academic_class/', { params: { 'student': student } });
	// }
	getStudentName_Class_year(student) {
		return this.httpClient.get('/students/academic_student/', {params: {'student': student}});
	}

	getcertificatedetails(student, course, marks, date) {
		return this.httpClient.get('/students/getcertificatedetails/', {
			params: {
				'student': student,
				'course': course,
				'marks': marks,
				'date': date
			}
		});
	}

	getFilterClass() {
		return this.httpClient.get('/students/getfilterclass/');
	}

	getClassMultiSelect(term) {
		return this.httpClient.get('/students/getclassbyterm/', {params: {'term': term}});
	}

	downloadTransferCertificate(student, marks, course, date) {
		return this.httpClient.get('/reports/downloadtransfercertificate/', {
			params: {student: student, marks: marks, course: course, date: date},
			headers: new HttpHeaders().append('Content-Type', 'application/pdf'),
			responseType: 'blob',
			observe: 'body'
		});
	}

	loadClasses() {
		// load student in parent add page: Multiple Select
		// load student in parent filter by student: Single Select
		this.class$ = concat(
			of([]), // default items
			this.classinput$.pipe(
				debounceTime(200),
				distinctUntilChanged(),
				switchMap(term => this.getClassMultiSelect(term).pipe(
					catchError(() => of([])), // empty list on error
					))
				)
			);
	}

	DeletePassoutData(student_id){
		return this.httpClient.post('/students/pass_out_student_delete/',student_id);
	}
	GetPassoutData(academic_year){
		return this.httpClient.get('/students/pass_out_student_delete/',{params:{'academic_year':academic_year}});

	}
	DeletAllPassoutData(academic_year){
		return this.httpClient.post('/students/pass_out_student_delete/',academic_year);
	}
	GetStudentdata(class_id){
		return this.httpClient.get('/students/student_admission_number_update/',{params:{class_id:class_id}});
	}


	validateStudentAdmissionNum(admission_no,user_id){
		return this.httpClient.get('/students/validate_admission_number/',{ params: {'admission_no': admission_no,'user_id':user_id}})
	}
	SaveAdmissionNumers(data){
		return this.httpClient.post('/students/student_admission_number_update/',data);
	} 


	postStudentForm(data){
		return this.httpClient.post("/students/student_new/",data)
	}

	GetStudentForm(id){
		return this.httpClient.get("/students/student_detail/",{ params:{'student_id':id}})
	}

	UpdateStudentForm(data){
		return this.httpClient.post("/students/update_student_form/",data)
	}

	getStudentSibilings(params){
		return this.httpClient.get("/students/get_student_sibilings/",{params:params})
	}

	getStudentListByFilter(params){
		return this.httpClient.get("/students/student_list_by_order/",{params:params})
	}

	searchParents(term){
		return this.httpClient.get("/dashboard/search_users/",{params: {'search_params': term,"exclude_users" : ['S','SU','A','AU','ZU','BUS']}});
	}

	postStudentRollNumber(data){
		return this.httpClient.post("/students/student_roll_number/",data);
	}

	postStudentNFCNumber(data){
		return this.httpClient.post("/students/student_nfc_number/",data);
	}
	getMissingNFCNumber(params){
		return this.httpClient.get("/students/student_nfc_number/",{params:params});
	}


	postStudentImages(data){
		return this.httpClient.post("/students/student_images/",data);
	}

	removeImageFile(params){
		return this.httpClient.delete("/students/student_images/",{params:params})
	}

	getStudentSettings(params){
		return this.httpClient.get('/students/student_settings/',{params:params})
	}
	postAdmissionSettings(data){
		return this.httpClient.post('/students/student_settings/',data)
	}
	attendancereports(params) {
		return this.httpClient.get('/reports/attendancereports/',{params:params})
	}

	attendancereportsPDF(params) {
		return this.httpClient.get('/reports/attendancereports/', {
			params: params,
			headers: new HttpHeaders().append('Content-Type', 'application/pdf'),
			responseType: 'blob',
			observe: 'body'
		});
	}

	changeStudentMigrationStatusChange(data){
		return this.httpClient.post("/students/student_migration_status_change/",data)
	}
	student_migration_status_change(params) {
		return this.httpClient.get('/students/student_migration_status_change/',{params:params})
	}

	UpdateStudentAddress(data){
		return this.httpClient.post('/students/update_student_address/',data);
	}
	getStudentAddress(params){
		return this.httpClient.get('/students/update_student_address/',{params: params});
	}

	getStudentSettingsDocumentFiles(params){
		return this.httpClient.get('/students/student_settings_document_files/',{params: params});
	}

	postStudentSettingsDocumentFiles(data){
		return this.httpClient.post('/students/student_settings_document_files/',data);
	}

	getStudentDocumentFiles(params){
		return this.httpClient.get('/students/student_document_files/',{params: params});
	}

	postStudentDocumentFiles(data){
		return this.httpClient.post('/students/student_document_files/',data);
	}

	deleteDocumentFiles(params){
		return this.httpClient.delete('/students/student_document_files/',{params: params});
	}

	changeStudentPassword(data){
		return this.httpClient.post('/students/reset_student_password/', data)
	}
}
